export default __webpack_public_path__ + "static/media/sp_common_mobile.25cc864e.png";